// extracted by mini-css-extract-plugin
export default {"selectBox":"suggestionSelectField_selectBox__6a25a"};